export default __webpack_public_path__ + "static/media/UlianaLovelace.6968f41b.png";